export interface ScopeCopy {
  label: string;
  title: string;
  editorialTitle: string;
  heroTagline: string;
  regionsTitle: string;
  projectTagline: string;
  metaTitle: string;
  metaDescription: string;
}

export const SCOPE: ScopeCopy = {
  label: 'Southwest Olive Guide',
  title: 'Texas, New Mexico, and Arizona',
  editorialTitle: 'The Southwest Olive Guide',
  heroTagline:
    'Plan Southwest olive oil tastings, mill visits, orchard stops, and food-focused weekend trips across Texas, New Mexico, and Arizona.',
  regionsTitle: 'Southwest olive-route regions',
  projectTagline: 'Curated olive-oil tasting weekends across the Southwest.',
  metaTitle: 'Olive Oil Trails | Southwest Olive Guide',
  metaDescription:
    'A curated Southwest olive guide through Texas, New Mexico, and Arizona, with verified tasting stops and Stay22-powered hotel planning.',
};
